import { Box, Button, Text, Group, Stack } from '@mantine/core';
import { colors, fontSize } from '../constants';
import PropTypes from 'prop-types';
import fullSun from '../images/ui_buttons/full_sun_button.png';
import filterSun from '../images/ui_buttons/filter_sun_button.png';
import fullShade from '../images/ui_buttons/full_shade_button.png';

const { white } = colors;

const SunlightSelectorMobile = ({
	style,
	sunlight,
	onSunlightSelect,
	onBack
}) => {
	// Logic for choosing selected sunlight
	const handleSelectSunlight = (sunlightId) => {
		console.log('SunlightSelectorMobile received click on', sunlightId);
		onSunlightSelect(sunlightId);
	};

	return (
		<Box style={{ 
			height: '100vh', 
			width: '100vw',
			display: 'flex', 
			flexDirection: 'column',
			backgroundColor: colors.mobileBackground,
			position: 'fixed',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			overflow: 'hidden',
			boxSizing: 'border-box'
		}}>

			{/* Header */}
			<Box style={{
				backgroundColor: colors.backgroundLight,
				height: '120px',
				padding: '10px 10px',
				zIndex: 10,
				position: 'relative',
				borderBottom: `12px solid ${colors.white}`,
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'flex-end',
				alignItems: 'center'
			}}>
				<Text style={{
					color: white,
					fontSize: fontSize.xxxl,
					fontWeight: 'bold',
					textAlign: 'center'
				}}>
					Level of Sunlight
				</Text>
			</Box>

			{/* Navigation Bar */}
			<Group justify="space-between" align="center" style={{ 
				padding: '20px 25px',
				zIndex: 10,
				position: 'relative',
				height: '84px',
				flexShrink: 0
			}}>
				<Button
					variant="filled"
					onClick={onBack}
					styles={{
						root: {
							backgroundColor: colors.buttonColor,
							color: colors.white,
							border: 'none',
							borderRadius: '8px',
							padding: '8px 20px',
							fontWeight: 'bold',
							minHeight: '44px',
							fontSize: fontSize.lg,
						}
					}}
				>
					Back
				</Button>
				
				{/* Empty space for right side to maintain balance */}
				<Box style={{ width: '80px' }} />
			</Group>

			{/* Main Content Area */}
			<Box style={{ 
				flex: 1,
				minHeight: 0,
				position: 'relative',
				display: 'flex',
				flexDirection: 'column',
				overflow: 'hidden',
				paddingBottom: '30vh'
			}}>
				{/* Sunlight Options Container */}
				<Box style={{
					flex: 1,
					minHeight: 0,
					position: 'relative',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					overflow: 'hidden',
					padding: '20px'
				}}>
					<Group gap="0px" style={{ width: '100%', justifyContent: 'center' }}>
						{/* Full Sun Option */}
						<Button
							variant="filled"
							onClick={() => handleSelectSunlight('full_sun')}
							styles={{
								root: {
									backgroundColor: sunlight === 'full_sun' ? colors.green : colors.buttonColor,
									border: sunlight === 'full_sun' ? '2px solid #475a46' : '2px solid #666',
									borderRadius: '15px',
									height: '18vh',
									width: '100%',
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'center',
									justifyContent: 'center',
									padding: '0px',
									flex: 1
								}
							}}
						>
							<Stack align="center" gap="8px" style={{ width: '100%' }}>
								<img 
									src={fullSun} 
									alt='Full Sun' 
									style={{ 
										width: '100%', 
										height: '100%'
									}} 
								/>
								<Text style={{
									fontSize: fontSize.base,
									fontWeight: 'bold',
									color: colors.white,
									textAlign: 'center'
								}}>
									Full Sun
								</Text>
							</Stack>
						</Button>

						{/* Filter Sun Option */}
						<Button
							variant="filled"
							onClick={() => handleSelectSunlight('filter_sun')}
							styles={{
								root: {
									backgroundColor: sunlight === 'filter_sun' ? colors.green : colors.buttonColor,
									border: sunlight === 'filter_sun' ? '2px solid #475a46' : '2px solid #666',
									borderRadius: '15px',
									height: '18vh',
									width: '100%',
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'center',
									justifyContent: 'center',
									padding: '0px',
									flex: 1
								}
							}}
						>
							<Stack align="center" gap="8px" style={{ width: '100%' }}>
								<img 
									src={filterSun} 
									alt='Filter Sun' 
									style={{ 
										width: '100%', 
										height: '100%'
									}} 
								/>
								<Text style={{
									fontSize: fontSize.base,
									fontWeight: 'bold',
									color: colors.white,
									textAlign: 'center'
								}}>
									Filter Sun
								</Text>
							</Stack>
						</Button>

						{/* Full Shade Option - only show if not tropical or waterwise */}
						{style !== 'tropical' && style !== 'waterwise' && (
							<Button
								variant="filled"
								onClick={() => handleSelectSunlight('full_shade')}
								styles={{
									root: {
										backgroundColor: sunlight === 'full_shade' ? colors.green : colors.buttonColor,
										border: sunlight === 'full_shade' ? '2px solid #475a46' : '2px solid #666',
										borderRadius: '15px',
										height: '18vh',
										width: '100%',
										display: 'flex',
										flexDirection: 'column',
										alignItems: 'center',
										justifyContent: 'center',
										padding: '0px',
										flex: 1
									}
								}}
							>
								<Stack align="center" gap="8px" style={{ width: '100%' }}>
									<img 
										src={fullShade} 
										alt='Full Shade' 
										style={{ 
											width: '100%', 
											height: '100%'
										}} 
									/>
									<Text style={{
										fontSize: fontSize.base,
										fontWeight: 'bold',
										color: colors.white,
										textAlign: 'center'
									}}>
										Full Shade
									</Text>
								</Stack>
							</Button>
						)}
					</Group>
				</Box>
			</Box>
		</Box>
	);
};

SunlightSelectorMobile.propTypes = {
	style: PropTypes.string,
	sunlight: PropTypes.string,
	onSunlightSelect: PropTypes.func.isRequired,
	onBack: PropTypes.func.isRequired
};

export default SunlightSelectorMobile;
